import { useEffect, createContext, useState, useContext } from 'react';
import { FormControl, RadioGroup, FormControlLabel, Stack, Radio, Typography } from '@mui/material';
import { PaymentMethod, TransactionStatus } from 'enums';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Payment } from '@mui/icons-material';

const PaymentMethodContext = createContext();

const PaymentMethodProvider = ({ children }) => {
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

    const handlePaymentMethodChange = (newMethod) => {
        console.log('handlePaymentMethodChange', newMethod);
        setSelectedPaymentMethod(newMethod);
    };

    return (
        <PaymentMethodContext.Provider value={{ selectedPaymentMethod, handlePaymentMethodChange }}>
            {children}
        </PaymentMethodContext.Provider>
    );
};

PaymentMethodProvider.propTypes = {
    children: PropTypes.node.isRequired
};

const usePaymentMethod = () => {
    const ctx = useContext(PaymentMethodContext);
    if (!ctx) {
        throw new Error('usePaymentMethod must be used within a PaymentMethodProvider');
    }
    return ctx;
};

const PaymentMethodSelector = ({ transactionStatus, cardEnabled, bankEnabled }) => {
    const { t } = useTranslation();
    const { handlePaymentMethodChange, selectedPaymentMethod } = usePaymentMethod();

    const paymentMethods = Object.entries(PaymentMethod).map(([key, value]) => ({ key, value }));

    // // TODO: Add PaymentMethod in TransHeader and remove this useEffect
    // useEffect(() => {
    //     handlePaymentMethodChange(PaymentMethod.bank.id);
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    return (
        <Stack spacing={2} sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
            <Stack direction="row" alignItems="center" spacing={2}>
                <Typography variant="h4" fontSize="16px">
                    {t('PaymentMethod')}
                </Typography>
                <Payment />
            </Stack>
            <FormControl>
                <RadioGroup
                    onChange={(event) => {
                        handlePaymentMethodChange(event.target.value);
                    }}
                    aria-labelledby="payment-radio-buttons-group-label"
                    name="radio-buttons-group"
                    value={selectedPaymentMethod}
                >
                    {paymentMethods.map(({ key, value }) => {
                        const { id, name } = value;
                        if (!cardEnabled && id === PaymentMethod.card.id) return null;
                        if (!bankEnabled && id === PaymentMethod.bank.id) return null;
                        return (
                            <FormControlLabel
                                key={key}
                                value={id}
                                disabled={transactionStatus !== TransactionStatus.pendingPayment}
                                control={<Radio />}
                                label={t(name)}
                            />
                        );
                    })}
                </RadioGroup>
            </FormControl>
        </Stack>
    );
};

PaymentMethodSelector.propTypes = {
    transactionStatus: PropTypes.number,
    cardEnabled: PropTypes.bool,
    bankEnabled: PropTypes.bool
};

export { PaymentMethodProvider, PaymentMethodSelector, usePaymentMethod };
